export default {"src":"/_next/static/media/crunch-logo-pink.729387a7.svg","height":57,"width":282,"blurWidth":0,"blurHeight":0};